import apisauce from "apisauce";
import { once } from "./utils";

const BASE_URL = "https://staging.sparkbackend.cerebry.co/";
const teacherDashboardAPI = "teacher_dashboard";
const apiV1Class = "api/v1/classes";
import { getCurrentUrl } from "preact-router";
const query = {};
if(typeof window !== "undefined") {

  getCurrentUrl() &&
  getCurrentUrl()
  .split("?")[1] &&
  getCurrentUrl()
  .split("?")[1].split("&") &&
  getCurrentUrl()
  .split("?")[1].split("&")
  .forEach((item) => {
    const [key, value] = item.split("=");
    if (key && value) {
      query[key] = value;
    }
  });
}


const create = (baseURL = BASE_URL) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 10000,
  });

  const setAccessToken = (token) => {
    return api.setHeader("Authorization", token);
  };

  const removeAccessToken = () => {
    delete api.headers["Authorization"];
  };

  const retryApiSauce = (response) => {
    let methodType = response.config.method.toUpperCase();
    switch (methodType) {
      case 'GET':
        return api.get(response.config.url,response.config.params);
      case 'POST':
        return api.post(response.config.url,response.config.data);
      case 'PUT':
        return api.put(response.config.url,response.config.data);
      case 'DELETE':
        return api.delete(response.config.url,response.config.params);
      default:
        return api.any(response.config);
    }
  }

  const check401 = once((refreshToken) => {
    api.addAsyncResponseTransform(async (response) => {
      let status = response.status || response.data.status;
      let apiUrl = response.url || response.config.url;
      const apiImmuned401 = `api/v2/users/refresh`;
      if(status == 401 && apiUrl.indexOf(apiImmuned401) < 0) {
          setAccessToken(refreshToken);
          const updatedJwtTokenResponse = await refreshUser();
          if(updatedJwtTokenResponse.status != 401 && updatedJwtTokenResponse.data && updatedJwtTokenResponse.data.jwt) {
            let newJwtToken = "jwt "+updatedJwtTokenResponse.data.jwt;
            setAccessToken(newJwtToken);
            saveJWT(JWT_TOKEN,updatedJwtTokenResponse.data.jwt);
            const updatedResponse = await retryApiSauce(response);
            if(updatedResponse && updatedResponse.status != 401 && updatedResponse.data) {
              //this line is not mutating the response, so setting the corresponding values alone.
              //response = updatedResponse;
              response.data = updatedResponse.data;
              response.status = updatedResponse.status;
            }
          } else {
            response.tokenRefreshed = true;
          }
      }
    });
  });

  const getMe = () => {
    return api.get(`api/v2/users/me/`);
  };

  const refreshUser = () => {
    return api.post(`api/v2/users/refresh/`);
  };

  const fetchCurriculums = (payload) => {
    const { subject } = payload.payload;
    return api.get(`cc/${subject}/curriculums/`,{language: query["language"] || "english"});
  };

  const fetchGrades = (payload) => {
    const { id } = payload.payload;
    if(query["practice_curriculum"]){
      return api.get(`cc/curriculum-tag/M/grades/`,{language: query["language"] || "english"});
    }
    return api.get(`cc/curriculum-tag/${id}/grades/`,{language: query["language"] || "english"});
  };

  const fetchGradeDetails = (payload) => {
    const { curriculumId, gradeId } = payload.payload;
    if(query["internal"]){
      return api.get(`cc/curriculum-tag/${curriculumId}/grade-tag/${gradeId}/details/?internal=${query["internal"]}`,{language: query["language"] || "english"});
    } else {
      return api.get(`cc/curriculum-tag/${curriculumId}/grade-tag/${gradeId}/details`,{language: query["language"] || "english"});
    }
    };

  const fetchSkillConfigs = (payload) => {

    const { topic, offset, limit, difficulty, question_type, filterKey, filterVal } = payload.payload;
    if(filterKey && filterVal){
      return api.get(`cc/skill-tag/${payload.payload.skillId}/config_types/`, {
        limit,
        offset,
        difficulty,
        question_type,
        language: query["language"] || "english",
        filter_key: filterKey,
        filter_val: filterVal,
      });
    }
    return api.get(`cc/skill-tag/${payload.payload.skillId}/config_types/`, {
      limit,
      offset,
      difficulty,
      question_type,
      language: query["language"] || "english",
    });
  };

  const fetchCCFilters = () => {
    return api.get(`cc/cc-filter/`);
  };
  const fetchCCSubjects = () => {
    return api.get(`cc/subjects/`,
    {
      language: query["language"] || "english",
    }
    );
  };

  const fetchTopicConfigs = (payload) => {
    const { topic, curriculum, grade,offset, limit ,difficulty,filterKey,filterVal } = payload.payload;
    if(filterKey && filterVal){

      return api.get(
        `/cc/curriculum-tag/${curriculum}/grade-tag/${grade}/topic-tag/${topic}/config_types/`,
      {
        limit,
        offset,
        language: query["language"] || "english",
        filter_key:filterKey,
        filter_val:filterVal,
      }
      );
    }else {
      return api.get(
        `/cc/curriculum-tag/${curriculum}/grade-tag/${grade}/topic-tag/${topic}/config_types/`,
      {
        limit,
        offset,
        language: query["language"] || "english"
      }
      );
    }
  };


  const fetchConceptConfigs = (payload) => {
    const { topic, offset, curriculum, grade, limit, filterKey,filterVal } =
      payload.payload;
    if(filterKey && filterVal){
      return api.get(
        `cc/curriculum-tag/${curriculum}/grade-tag/${grade}/concept-tag/${topic}/config_types/`,
        {
          limit,
          offset,
          language: query["language"] || "english",
          filter_key:filterKey,
          filter_val:filterVal,
        }
      );
    }
    return api.get(

      `cc/curriculum-tag/${curriculum}/grade-tag/${grade}/concept-tag/${topic}/config_types/`,
      {
        limit,
        offset,
        language: query["language"] || "english",
      }
    );
  };

  // const sendDownloadRequest = (payload, classCode) => {
  //   return api.post(`cc/class/${classCode}/create-cc-exam/`,payload);
  // };

  const sendDownloadRequest = (payload,classCode) => {
    const { solution, data ,downloadType} = payload.payload;
    console.log(payload.payload)
    if(downloadType=="Offline"){
      if(query["language"]){
        return api.post(`cc/download-paper/?solution=${solution}&auth=true&language=${query["language"] || "en"}`,data);
      }
      return api.post(`cc/download-paper/?solution=${solution}&auth=true`,data);
    }
    if(downloadType=="Online"){ 
      return api.post(`cc/class/${classCode}/create-cc-exam/`,data);
    }

  };
  
  return {
    setAccessToken,
    removeAccessToken,
    check401,
    getMe,
    refreshUser,
    fetchCurriculums,
    fetchGrades,
    fetchGradeDetails,
    fetchSkillConfigs,
    fetchCCFilters,
    fetchCCSubjects,
    fetchTopicConfigs,
    fetchConceptConfigs,
    sendDownloadRequest,
  };
};

export default create();
